// @flow
import styled, { keyframes } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  p, mb, pb, px, pt, mx, pr, mt
} from 'styled-components-spacing';
import { buttonLight, StyledWhatsappButton } from '@styles/buttons';
import { linkButtonTransparentBright } from '@styles/links';
import coverImagesNew from '@images/home/home-doc.svg';
import theme from '@theme';
import { colors } from '@components/ListItemFacility/styles';

const transitionRightToLeft = keyframes`
  from {
    right: -100%;
  }
  to {
    right: 0;
  }
`;

const transitionLeftToRight = keyframes`
  from {
    left: -100%;
  }
  to {
    left: 0;
  }
`;

const transitionDownToUp = keyframes`
  from {
    transform: translateY(10%);
  }
  to {
    transform: translateY(0%);
  }
`;

const transitionOpacity = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const StyledCover = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;

  ${breakpoint('mobile', 'tablet')`
    min-height: unset;
  `}
`;

export const StyledNumber = styled.div`
  font-size: 18px;
  margin: auto;
  color: #3770d4;
  font-weight: bold;
`;

export const StyledDetail = styled.div`
  margin: auto;
  font-size: 14px;
  color: #5a6374;
  margin-top: 4px;
`;

export const StyledText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledDialog = styled.div`
  position: relative;
  top: 168px;
  right: 64px;
  margin-left: 364px;
  display: none;
  align-items: center;
  height: 64px;
  background: #ffff;
  border-radius: 32px;
  box-shadow: 0 0 10px #bbb;
  width: 220px;

  ${breakpoint('desktop')`
    display: flex;
    animation: ${({ animate }) => (animate ? transitionRightToLeft : 'none')} 1.7s ease-out 1, 
      ${({ animate }) => (animate ? transitionOpacity : 'none')} 1.3s ease-in 1;
  `}
`;

export const StyledContentCover = styled.div`
  width: 100%;
  min-height: 100%;
  ${breakpoint('mobile', 'desktop')`
  
  `}
  
  ${breakpoint('desktop')`
    width: 100%;
  `}

  ${breakpoint('largeDesktop')`
    width: 100%
  `}
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  ${px(3)}
  ${pt(3)}
  ${pb(3)}
  ${mt(4)}
  ${breakpoint('desktop')`
    ${p(3)}
  `}

  ${breakpoint('mobile', 'tablet')`
    margin-top: 0px;
  `}
`;

export const StyledAllButton = styled.a`
  width: 300px;
  height: 50px;
  background-color: ${props => (props.bottom ? colors.white : colors.aquaMarine)};
  margin: 3rem auto;
  ${theme.shadows.medium};
  color: ${props => (props.bottom ? colors.aquaMarine : colors.white)};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
  border-radius: 15px;
  text-decoration: none;
  font-size: 22px;
  ${mt(5)}
  ${breakpoint('mobile', 'desktop')`
    width: 200px;
    height: 40px;
    font-size: 16px;
    margin-top: 0px;
  `}
  ${breakpoint('tablet', 'desktop')`
     margin-top: 5rem;
     margin-bottom: 0rem;
  `}
  @media (min-width: 1024px) and (max-width: 1700px){
    ${mt(5)}
  }
  &:hover{
    transform: scale(0.95);
    transition: 0.3s;
  }
`;


export const StyledContactButton = styled(StyledWhatsappButton)`
  background-color: #25d366;
  margin-top: 4rem;
  margin-bottom: 2rem;
  border-radius: 10px;
  pointer: cursor;
  
  ${breakpoint('mobile', 'desktop')`
    padding: 6px;
    ${mt(4)}
    margin-bottom: 0;
  `}
  @media(max-width: 240px) {
    padding: 5px;
    margin-top: 2rem;
  }

  ${breakpoint('desktop')`
    padding: 10px;
  `}

  &:hover{
    transform: scale(0.95);
    transition: 0.3s;
  }
`;

export const StyledImageContainer = styled.div`
  height: calc(100% - 40px);
  display: flex;
  flex-direction: row-reverse;
  ${pr(4)}

  ${breakpoint('desktop')`
    width: 48%;
    ${pr(4)}
    ${pt(4.5)}
  `}

  ${breakpoint('largeDesktop')`
    ${p(4.5)}
    width: 44%;
  `}
`;

export const StyledCoverBlock = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoint('desktop')`
    flex-direction: row;
  `}
`;

export const StyledImage = styled(coverImagesNew)`
  object-fit: contain;
  background-size: cover;
  background-position: center;
  ${breakpoint('mobile', 'desktop')`
    width: 70%;
    height:100%;
  `}

  ${breakpoint('desktop')`
    visibility: visible;
    max-width:100%;
    max-height:100%;
    animation: ${({ animate }) => (animate ? transitionDownToUp : 'none')} 1.5s ease-out 1, 
      ${({ animate }) => (animate ? transitionOpacity : 'none')} 1.2s ease-in 1;

    color: ${theme.colors.error};
  `}
`;

export const StyledLogo = styled.img`
  position: relative;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  padding-left: 21px;
  background-size: cover;
  background-position: center;
`;

export const StyledHeader = styled.div`
  z-index: 1;
`;

export const StyledButton = styled.a`
  ${buttonLight}
  ${mx(2.5)}
  background: none;
  text-decoration: none;
  justify-content: center;
  width: 100%;
  ${({ disabled }) =>
    (disabled
      ? `
    visibility: hidden;
  `
      : '')}

  ${breakpoint('desktop')`
    width: 50%;
  `}

  ${breakpoint('mobile', 'desktop')`
    justify-content: center;
    font-size: 14px;
    width: 56%;
    box-shadow: none;
    padding: 10px 28px 10px 28px;
  `}

  @media (max-width: 1000px) {
    width: 36%;
  }

  @media (max-width: 600px) {
    width: 56%;
  }

  @media (max-width: 320px) {
    font-size: 12px;
    width: 56%;
  }
`;

export const StyledHeadlineText = styled.h2`
  position: relative;
  width: 100%;
  font-size: 22px;
  font-weight: normal;
  font-weight: 700;
  font-family: Roboto, Arial, Helvetica, sans-serif !important;
  line-height: 1.4;
  text-align: center;
  overflow-wrap: break-word;
  color: ${props => (props.bottom ? colors.white : colors.navyGray)};

  ${theme.typography.Raleway}

  ${mb(4)}

  ${breakpoint('tablet')`
    font-size: 28px;
    ${mb(4.5)}
  `}

  ${breakpoint('desktop')`
    text-align: center;
    font-size: 32px;
    ${mb(2)}
  `}

  ${breakpoint('mobile', 'tablet')`
    margin-bottom: 0px;
    font-size: 20px;
  `}
`;

export const StyledSubheadlineText = styled.div`
  position: relative;
  font-size: 18px;
  text-align: center;
  color: #242a388a;
  font-family: Roboto, Arial, Helvetica, sans-serif !important;
  font-family: 'Open Sans' !important;
  line-height: 1.4;
  display: none;

  ${mb(4)}

  ${breakpoint('tablet')`
    display: inherit;
    ${mb(4.5)}
    font-size: 24px;
    max-width: 430px;
  `}

  ${breakpoint('desktop')`
    display: inherit;
    animation: ${({ animate }) => (animate ? transitionLeftToRight : 'none')} 1.3s ease-out 1, 
    ${({ animate }) => (animate ? transitionOpacity : 'none')} 1.1s ease-in 1;

    text-align: left;
  `}
`;

export const PreferencesWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 10px -48px;
  background-color: #21356a;
  max-width: 1150px;
  margin: auto;
  height: 180px;
  align-content: space-evenly;
  border-radius: 20px;
  margin-bottom: 100px;

  justify-items: center;
  & > div {
    width: 100%;
  }

  @media only screen and (min-width: 1030px) and (max-width: 1149px) {
    margin-left: 10px;
    margin-right: 10px;
  }

  ${breakpoint('mobile', 'desktop')`
    margin-left: 10px;
    margin-right: 10px;
  `}

  & div:last-child {
    border: none;
  }

  @media (max-width: 568px) {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
`;

export const StyledLinkMore = styled.a`
  display: flex;
  flex-direction: row;
  cursor: pointer;

  ${linkButtonTransparentBright}
  border-radius: 45px;
  padding-left: 4rem !important;
  padding-right: 4rem !important;

  ${breakpoint('mobile', 'desktop')`
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    font-size: 14px;
  `}
`;

export const StyledLinkDiv = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const StyledTextDiv = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const LabelTitle = styled.h2`
  margin-left: 100px;
  text-transform: uppercase;
  font-size: 20px;
  line-height: 1.5;
  color: ${theme.colors.white};
  font-weight: 800;
  position: relative;

  ${breakpoint('mobile', 'desktop')`
    margin-left: 30px;
    font-size: 16px;
  `}

  ${breakpoint('desktop')`
    font-size: 30px;
    animation:
      ${transitionDownToUp} ${({ animateTime }) => animateTime}s ease-out 1, 
      ${transitionOpacity} ${({ animateTime }) => animateTime}s ease-in 1
  `}
`;

export const Details = styled.p`
  color: #ffffffbf;
  margin: 0;
  text-align: center;
  position: relative;
  font-size: 15px;

  ${breakpoint('desktop')`
    font-size: 24px;
    animation:
      ${transitionDownToUp} ${({ animateTime }) => animateTime}s ease-out 1, 
      ${transitionOpacity} ${({ animateTime }) => animateTime}s ease-in 1
  `}
`;

export const StyledButtonCover = styled.div`
  display: flex;
  flex-direction: row;

  ${breakpoint('tablet')`
    bottom: -40px;
    max-width: 400px;
    margin-right: 80px;
  `}

  ${breakpoint('desktop')`
    flex-direction: row;
    max-width: 400px;
    margin: 0;
    animation: none;
    animation: ${({ animate }) => (animate ? transitionLeftToRight : 'none')} 1.8s ease-out 1, 
      ${({ animate }) => (animate ? transitionOpacity : 'none')} 1.6s ease-in 1;
  `}

  ${breakpoint('largeDesktop')`
      position: relative;
  `}

`;

export const StyledBannerSeperatorBlock = styled.div`
  ${mt(6)}

  ${breakpoint('mobile', 'tablet')`
    ${mt(4)}
  `}
  ${breakpoint('tablet', 'desktop')`
    margin-top: 5rem;
  `}
`;
